import { DataPrivacyClassification } from "../DataCategoriesStep/DataCategoriesStep.types";
import { LevelOfProtectionType } from "../../legalEntity/addLegalEntityDialog/AddLegalEntityDialog.types";
import { SecurityMeasureOverviewModel } from "../dataSubjectStep/DataSubjectStep.types";
import {
    NumberOfDataSubjectsEnum,
    NumberOfProcessorsEnum,
    SelectableColoredItem,
    SelectableDataCategoryItem,
    SelectableLegalUnitsItem,
} from "../ProcessingActivity.types";
import { PolicyType } from "../../policy/policies/Policies.types";
import { ProcessingActivityStatus } from "../processingActivities/ProcessingActivities.types";

export interface ProcessingActivitySharingsViewModel {
    sharings: Array<SharingRowModel>;
    dataCategories: Array<SelectableDataCategoryItem>;
    senders: Array<SelectableLegalUnitsItem>;
    recipients: Array<SelectableLegalUnitsItem>;
}

export interface ProcessingActivityTopBarViewModel {
    id: string;
    userFriendlyId: string;
    name: string;
    description: string;
    note?: string | null;
    processingActivityStatus: ProcessingActivityStatus;
    purposes?: string | null;
    dataSubjects?: string | null;
    securityMeasures: Array<SecurityMeasureOverviewModel>;
    policies: Array<PolicyViewItem>;
    businessAreas: Array<SelectableColoredItem>;
    tags: Array<SelectableColoredItem>;
    responsible?: string | null;
    responsibleActive?: boolean | null;
    numberOfSubjects?: NumberOfDataSubjectsEnum | null;
    numberOfProcessors?: NumberOfProcessorsEnum | null;
    noOfSubjects?: number | null;
    noOfProcessors?: number | null;
    progress?: number | null;
    validation?: ValidationViewModel | null;
    canValidateProcessingActivity: boolean;
    isValidationDue: boolean;
    approvalNumber?: string | null;
}

export interface ProcessingActivityTabCountsViewModel {
    dataCategories: number;
    assets: number;
    documents: number;
    audits: number;
    classifications: number;
}

export interface ProcessingActivityProgressViewModel {
    id: string;
    progress: number;
}

export interface SharingRowModel {
    name: string;
    description: string;
    senderName: string;
    senderId: string;
    senderRole: string;
    dataCategories: Array<DataCategoryOnSharing>;
    recipientName: string;
    recipientId: string;
    recipientRole: string;
    legalBasisList: Array<string>;
    transferBasis: string;
    deletionPeriods: Array<string>;
    system: string;
    systemId: string;
    recipientInThirdCountry: boolean;
    thirdCountryOrigin?: ThirdCountryOrigin;
    subStep: number;
    sharingId: string;
    recipientLevelOfProtection: LevelOfProtectionType;
    sharingOrigin: SharingOrigin;
}

export interface SharingRowTableModel extends SharingRowModel {
    dataCategoriesString: string;
}

export interface SharingOrigin {
    systemId: string;
    dataProcessorId: string;
    dataControllerId: string;
    transferId: string;
    sourceId: string;
    jointDataControllerId: string;
}

export enum SharingTypeEnum {
    dataProcessor,
    disclosure,
    source,
    dataController,
    jointDataController,
}

export enum ThirdCountryOrigin {
    DataProcessor = 1,
    StorageLocation = 2,
}

export interface LegalBasesDialogViewModel {
    name: string;
    id: string;
    classification: DataPrivacyClassification;
    dataCategoryViewItems: Array<DataCategoryViewItem>;
}

export interface DataCategoryViewItem {
    directive: string;
    doubleBasis: string;
    nationalLaw: string;
    deletionPeriod: string;
    purpose: string;
}

export interface ValidationViewModel {
    validatedBy?: string;
    validatedDate: Date;
}

export interface ProcessingActivityValidationSaveModel {
    processingActivityId: string | undefined;
}

export interface PolicyViewItem {
    id: string;
    name: string;
    type: PolicyType;
}

export enum ControllerProcess {
    None = -1,
    Controller,
    ProcessorW,
    Datasubject,
    Subprocessor,
    SubsidiaryPerson,
    JointControllers,
}

interface DataCategoryOnSharing {
    name: string;
    id: string;
    description?: string;
    dataTypeIds: string[];
}

export enum ProcessingActivityPlanTabId {
    Sharings = "sharings",
    DataCategories = "dataCategories",
    Assets = "assets",
    Documents = "documents",
    Audits = "audits",
    Classifications = "classifications",
    Tasks = "tasks",
}
